import { type AddToCartEvent } from './base/ga4-events'

export const AddToCartStatus = {
  SUCCESS: {
    code: '001',
    message: 'ATC Success',
  },
  MEMBER_ONLY: {
    code: '002',
    message: 'ATC Fail. Guest attempting to add member-only products.',
  },
} as const

export const codes = Object.values(AddToCartStatus).map(item => item.code)
export const messages = Object.values(AddToCartStatus).map(item => item.message)
export type AddToCartStatusCode = typeof codes[number]
export type AddToCartStatusMessage = typeof messages[number]

export interface WordpressAddToCartEvent extends AddToCartEvent {
  eventName: 'add_to_cart'
  eventParams: AddToCartEvent['eventParams'] & {
    status_code: AddToCartStatusCode
    status_message: AddToCartStatusMessage
  }
}

export type WordpressGa4Events =
  | WordpressAddToCartEvent
